import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import FancyImage from "components/FancyImage";
import css from "./video.module.scss";

class Video extends React.Component {
    static propTypes = {
        videos: PropTypes.array,
        isMobile: PropTypes.bool,
        test: PropTypes.bool,
        fallbackImage: PropTypes.object,
        isFixed: PropTypes.bool,
        hasGradient: PropTypes.bool,
    };
    render() {
        const video =
            this.props.videos.find(
                (v) => v.label === (this.props.isMobile ? "mobile" : "desktop")
            ) || this.props.videos[0];

        if (!video) return <FancyImage {...this.props.fallbackImage} />;

        return (
            <div
                className={cn(css.videoWrapper, "video-wrapper", {
                    [css.fixed]: this.props.isFixed,
                    [css.hasGradient]: this.props.hasGradient,
                })}
            >
                {video.poster && (
                    <div
                        className={css.videoBg}
                        style={{
                            backgroundImage: `url(${video.poster})`,
                        }}
                    ></div>
                )}
                <video
                    className={css.video}
                    loop
                    muted="true"
                    autoPlay
                    playsInline
                    src={video.src}
                />
            </div>
        );
    }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/Video.jsx